/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-unresolved */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Box, Card, IconButton, Button,
} from "@mui/material";
import {checkUserAllowed, getLocalDate, getLogo} from "helpers/utils";
import { useHistory } from "react-router-dom";

import { Link } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ViewListIcon from '@mui/icons-material/ViewList';
import EditIcon from "@mui/icons-material/Edit";
import PercentIcon from '@mui/icons-material/Percent';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import AddCommentIcon from '@mui/icons-material/AddComment';
import InstagramIcon from '@mui/icons-material/Instagram';
import "./AdminSellerShop.scss";
import HoverBox from "components/HoverBox";
import LazyImage from "components/LazyImage";
import { H2, H4, H5 } from "components/CustomTypography";
import {DATE_TIME_FORMAT_SHORT} from "config/constants";

const AdminSellerShop = (props) => {
  const [state, setState] = useState({
    open: false,
  });

  const history = useHistory();

  const {
    shop = {}, editProducts, editShopStatus, userDetails, editShopProfile, addShopOffer, editStandeeDelivery, addShopLog, editInstaProducts
  } = props;

  const onOpenModal = () => {
    setState({ open: true });
  };

  const onCloseModal = () => {
    setState({ open: false });
  };

  const handleProductsButtonClick = (shop) => {
    history.push(`/products/shop/${shop.id}`);
  };

  const handleOrdersButtonClick = (shop) => {
    history.push(`/orders/shop/${shop.id}`);
  };

    const handleShopButtonClick = (shop) => {
        history.push(`/shops/shop/${shop.id}`);
    };


  return (
      <Box mb={2}>
        <HoverBox  mb={0} mx="auto" borderRadius="2px" onClick={editShopStatus /* () => handleShopButtonClick(shop) */}>
          <LazyImage
              src={getLogo(shop.logo)}
              width={150}
              height={150}
              alt={shop.title}
              mx="auto"
          />
        </HoverBox>
        <H2 textTransform="uppercase" fontSize={12} textAlign="left" title={shop.title} ellipsis>
            {shop.title}
        </H2>
        <H4 textAlign="left">
            {checkUserAllowed(userDetails.userlevel, "products") &&
                <IconButton color="primary" size="small" onClick={editProducts}>
                    <ViewListIcon/>
                </IconButton>
            }
            {checkUserAllowed(userDetails.userlevel, "orders") &&
                <IconButton color="primary" size="small" onClick={() => handleOrdersButtonClick(shop)}>
                    <ShoppingCartIcon/>
                </IconButton>
            }
            {(checkUserAllowed(userDetails.userlevel, "verifyshop") ||
                checkUserAllowed(userDetails.userlevel, "approveshop")) &&
                <IconButton color="primary" size="small" onClick={editShopStatus}>
                    <MoreHorizIcon/>
                </IconButton>
            }
            {(checkUserAllowed(userDetails.userlevel, "editshop")) &&
                <IconButton color="primary" size="small" onClick={editShopProfile}>
                    <EditIcon />
                </IconButton>
            }

            {(checkUserAllowed(userDetails.userlevel, "shopaddoffers")) &&
                <IconButton color="primary" size="small" onClick={addShopOffer}>
                    <PercentIcon />
                </IconButton>
            }

            {(shop.display_status === "indelivery" && (checkUserAllowed(userDetails.userlevel, "displaydelivered"))) &&
                <IconButton color="primary" size="small" onClick={editStandeeDelivery}>
                    <QrCode2Icon />
                </IconButton>
            }

            {(checkUserAllowed(userDetails.userlevel, "shopaddlog")) &&
                <IconButton color="primary" size="small" onClick={addShopLog}>
                    <AddCommentIcon />
                </IconButton>
            }
            {shop.instahandle && checkUserAllowed(userDetails.userlevel, "instaprod") &&
                <IconButton color="primary" size="small" onClick={editInstaProducts}>
                    <InstagramIcon/>
                </IconButton>
            }
        </H4>
        <H5 fontSize={12} mb={1} textAlign="left" ellipsis>
            {shop.is_verified ? shop.sales_user && shop.sales_user.name : "Not verified"}  ({shop.status}) {shop.is_tracked && <b> High Priority</b>}
        </H5>
          <H5 fontSize={12} textAlign="left" ellipsis>
              Recent Product: <b>{shop.last_product_added_date ? getLocalDate(shop.last_product_added_date, DATE_TIME_FORMAT_SHORT) : 'None'}</b>
          </H5>
          <H5 fontSize={12} mb={1} textAlign="left" ellipsis>
              Video Calling: <b>{shop.appointment_enabled ? "Enabled" : "Disabled"}</b>
          </H5>
          <H5 fontSize={12} textAlign="left">
              Likes: {shop.likes} / Insta Followers: {shop.instagram_followers_count ? shop.instagram_followers_count : "NA"} / Avg Likes: {shop.instagram_avg_likes ? shop.instagram_avg_likes : "NA"}
          </H5>
          <H5 fontSize={12} mb={1} textAlign="left" ellipsis>
              Last Insta update: <b>{shop.instagram_last_synced ? getLocalDate(shop.instagram_last_synced, DATE_TIME_FORMAT_SHORT) : 'None'}</b>
          </H5>
          <H5 fontSize={12} textAlign="left">
              Products: {shop.count} / Offers: {shop.offers}
          </H5>

          <H5 fontSize={12} textAlign="left" ellipsis>
              Shop Added: {getLocalDate(shop.created_at, DATE_TIME_FORMAT_SHORT)}
          </H5>
      </Box>
  );
};

export default AdminSellerShop;
